module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Editor’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('strong', [_vm._v("Foreword")]), _vm._v(" by Willemien Otten")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('strong', [_vm._v("Introduction: Reflections on "), _c('i', [_vm._v("Sightings")])]), _vm._v(" by W. Clark Gilpin")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("Counting")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("America’s Mythical Religious Past")]), _vm._v(" by Catherine A. Brekus")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("Mourning a Monsignor")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("Pearl Harbor, Sarajevo, and the Events of September Eleventh")]), _vm._v(" by Edward McGlynn Gaffney Jr.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("An Extraordinary Discussion")]), _vm._v(" by Jean Bethke Elshtain")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("Of Patriots and Saints")]), _vm._v(" by Jonathan Ebel")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("“The Women” Are Everywhere")]), _vm._v(" by Amy Hollywood")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("Of Troubled Hearts")]), _vm._v(" by Christopher Beem")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "spaceb"
  }, [_c('strong', [_vm._v("A Letter from Jerusalem: Christmas 2002")]), _vm._v(" by Ithamar Gruenwald")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Ryan’s Commute")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Milton, Mass., Mary")]), _vm._v(" by Elizabeth Hayes Alvarez")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Cracking "), _c('i', [_vm._v("The Da Vinci Code")])]), _vm._v(" by Margaret M. Mitchell")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Remembering Martin Luther King")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Tru-Envy?")]), _vm._v(" by Jon Pahl")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Supreme Court Theology")]), _vm._v(" by Brian Britt")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Greeley’s War")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Theodicy of Everyday Life")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The World House")]), _vm._v(" by Robert M. Franklin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Collisions and Doubts")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Billy Graham’s Final Crusade")]), _vm._v(" by James L. Evans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Black Theology and Womanist Theology in Conversation")]), _vm._v(" by Dwight N. Hopkins")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Multiple Choices from the Founders")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Buddhists on the Brain")]), _vm._v(" by Dan Arnold")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Future of New Orleans")]), _vm._v(" by James B. Bennett")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Changing Faces of Islam")]), _vm._v(" by Malika Zeghal")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Reflections on Chicago’s "), _c('i', [_vm._v("Cloud Gate")])]), _vm._v(" by Jeremy Biles")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Intelligent Watches")]), _vm._v(" by Richard A. Rosengarten")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Sanctuary or Spectacle?")]), _vm._v(" by Cynthia Gano Lindner")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Allah’s Trailblazer")]), _vm._v(" by R. Jonathan Moore")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Watch Your Language")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("On the Migration of Religious Ideas")]), _vm._v(" by W. Clark Gilpin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Religion and Redemption in "), _c('i', [_vm._v("Black Snake Moan")])]), _vm._v(" by Kristen Tobey")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033#ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Mother Teresa’s Agony")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034#ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_c('i', [_vm._v("The Economist")]), _vm._v(" on Religion")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035#ch035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Baptism")]), _vm._v(" by Torture by William Schweiker")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036#ch036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("How to Bury a Prophet")]), _vm._v(" by Kathleen Flake")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037#ch037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("E Pluribus Obama")]), _vm._v(" by M. Cooper Harriss")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038#ch038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("God and Man at Yale")]), _vm._v(" by Eboo Patel")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039#ch039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("On Trust")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040#ch040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("News from the Religion and Science Front")]), _vm._v(" by Douglas Anderson")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041#ch041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("An Inner Life with New Meaning")]), _vm._v(" by Krista Tippett")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042#ch042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Economics")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043#ch043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Back to the Twelfth Century: Peter the Venerable and Pope Benedict XVI")]), _vm._v(" by Lucy K. Pick")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-044"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter044#ch044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Religion-Based Arguments in Juvenile Life without Parole Cases")]), _vm._v(" by Joan Gottschall")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter045#ch045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Sacred and the Sartorial")]), _vm._v(" by Courtney Wilder")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter046#ch046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Jim Wallis on Morals and Values")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter047#ch047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Keeping on the Sunny Side: Southern Traditionalism’s Bid for Academic Respectability and Tolerance")]), _vm._v(" by John Howell")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter048#ch048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Cuts in the Humanities")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter049#ch049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Persecution of Religious Minorities in Iraq")]), _vm._v(" by Shatha Almutawa")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter050#ch050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Franklin Graham on Islam and Violence")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter051#ch051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Shtetl Strongman")]), _vm._v(" by Sarah Imhoff")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter052#ch052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Good Sufi, Bad Muslims")]), _vm._v(" by Omid Safi")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter053#ch053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Chinese House Church Goes Public")]), _vm._v(" by Fenggang Yang")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter054#ch054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Shrine Destruction in Bahrain")]), _vm._v(" by Michael Sells")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter055#ch055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_c('i', [_vm._v("Machine Gun Preacher")])]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter056#ch056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_c('i', [_vm._v("Commonweal")]), _vm._v("’s “Bishops and Religious Liberty”")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter057#ch057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Adiaphora")]), _vm._v(" by Seth Perry")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-058"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter058#ch058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("A Jewish Classic for Muslims")]), _vm._v(" by James T. Robinson")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter059#ch059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Swift Rise and Apparent Demise of “Jesus’ Wife”")]), _vm._v(" by Trevor W. Thompson and David C. Kneip")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter060#ch060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Divorce’s Toll")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter061#ch061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Christian Pop")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-062"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter062#ch062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Strange Bedfellows Scapegoat Russia’s Gays")]), _vm._v(" by Bryce E. Rich")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-063"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter063#ch063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Doniger Affair: Freedom of Scholarly Inquiry Takes an Ominous Turn in India")]), _vm._v(" by Sunit Singh")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter064#ch064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Phone versus Online Honesty")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-065"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter065#ch065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Ferguson")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter066#ch066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("How Not to Understand ISIS")]), _vm._v(" by Alireza Doostdar")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-067"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter067#ch067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Plastic Religious Art: Playful to Some, Offensive to Others")]), _vm._v(" by Spencer Dew")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-068"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter068#ch068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("#JeSuisCharlie: Blasphemy in Hinduism and Censorship in India")]), _vm._v(" by Wendy Doniger")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-069"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter069#ch069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("After the "), _c('i', [_vm._v("Charlie Hebdo")]), _vm._v(" Massacre: Islam Must Open Itself to Critique")]), _vm._v(" by Jean-Luc Marion")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-070"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter070#ch070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("A Reply to Jean-Luc Marion’s “After "), _c('i', [_vm._v("Charlie Hebdo")]), _vm._v(", Islam Must Critique Itself”")]), _vm._v(" by Bruce Lincoln and Anthony C. Yu")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter071#ch071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Another Take on “After "), _c('i', [_vm._v("Charlie Hebdo")]), _vm._v(", Islam Must Critique Itself”")]), _vm._v(" by Matthew Kapstein")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-072"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter072#ch072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Rifts in the Mormon Family: What Just Happened?")]), _vm._v(" by Grant Hardy")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-073"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter073#ch073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Historic Paris Climate Agreement Reflects Years of Advocacy")]), _vm._v(" by Religious People by Sarah E. Fredericks")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-074"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter074#ch074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Southern Baptists")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-075"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter075#ch075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Easter’s "), _c('i', [_vm._v("Deus ex Machina")])]), _vm._v(" by Jeff Jay")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-076"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter076#ch076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Last Trump?")]), _vm._v(" by Roger Griffin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-077"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter077#ch077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Children on Christian or Secular Swings")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-078"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter078#ch078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("How Waiting 108 Years Makes the Good Life")]), _vm._v(" by Holly Swyers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-079"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter079#ch079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("An Event to Celebrate")]), _vm._v(" by Peter J. Paris")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-080"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter080#ch080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("In Defense of the Liberal in the Study of Religion")]), _vm._v(" by Jeffrey Stackert")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-081"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter081#ch081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Many Sightings of Hope")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-082"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter082#ch082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Dylann Roof, the Radicalization of the Alt-Right, and Ritualized Racial Violence")]), _vm._v(" by Joel A. Brown")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-083"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter083#ch083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Myths Debunked: Why Did White Evangelical Christians Vote for Trump?")]), _vm._v(" by Myriam Renaud")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-084"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter084#ch084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Rock, Paper, Scissors")]), _vm._v(" by Sarah Hammerschlag")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-085"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter085#ch085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Sacred Sites Violated")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-086"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter086#ch086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Church Militant")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-087"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter087#ch087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Time Has Passed")]), _vm._v(" by Emily D. Crews")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-088"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter088#ch088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Alien Citizens")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-089"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter089#ch089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Look for the Jews")]), _vm._v(" by Erika Tritle")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-090"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter090#ch090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Being Hip-Hop, Being Job, and Being")]), _vm._v(" by Julian “J.Kwest” DeShazier")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-091"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter091#ch091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Meaning of Religious Exemptions")]), _vm._v(" by Franklin I. Gamwell")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-092"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter092#ch092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Taking the Unitarian Universalist Diversity Crisis Seriously")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-093"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter093#ch093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("The Hidden Roots of Betsy DeVos’s Educational Policies")]), _vm._v(" by Willemien Otten")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-094"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter094#ch094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Rev. Dr. William Barber and the Sound of Transcendence")]), _vm._v(" by Braxton D. Shelley")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-095"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter095#ch095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Euthanasia, Dignity, and “Spirituality Lite”")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-096"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter096#ch096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Love Your Enemies: Moral Absurdity or Genius?")]), _vm._v(" by Audrey D. Thompson")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-097"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter097#ch097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Closings")]), _vm._v(" by Martin E. Marty")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-098"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter098#ch098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Visiting a Fellow Human at the Benedictine Monastery")]), _vm._v(" by Alan Levinovitz")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-099"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter099#ch099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99."), _c('span', {
    staticClass: "space1"
  }, [_c('strong', [_vm._v("Historical Justice in an Era of #MeToo: Legacies of John Howard Yoder")]), _vm._v(" by Rachel Waltner Goossen")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter100#ch100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100."), _c('span', {
    staticClass: "space05"
  }, [_c('strong', [_vm._v("Jerusalem")]), _vm._v(" by Paul Mendes-Flohr")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0